__turbopack_context__.v({
  "layoutContent": "LayoutContent-module__5H-QYW__layoutContent",
  "layoutContent__withAssistant": "LayoutContent-module__5H-QYW__layoutContent__withAssistant",
});
